import { ChangeDetectorRef, Component, OnInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import * as moment from "moment";
import { PhoneFormatPipe } from "../../pipes/phone-format.pipe";
import { LoaderService } from 'src/app/loader.service';
import * as saveAs from 'file-saver';

import { CommonPatternsService } from 'src/app/common-patterns.service';
import SwiperCore, { Navigation, EffectCoverflow, Pagination, SwiperOptions, Swiper, Virtual } from "swiper";
SwiperCore.use([Navigation, Pagination, EffectCoverflow]);



import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  ValidatorFn
} from '@angular/forms';
import Swal from 'sweetalert2';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ClipboardService } from 'ngx-clipboard'
import { ToastrService } from "ngx-toastr";
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult } from 'src/serviceworker/service/prefetch';
import { LoggerService } from 'src/app/services/logger.service';
import * as ClipboardJS from 'clipboard';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { loadAdvisorData, loadAdvisorDataSuccess } from 'src/app/state/actions/advisors.actions';
import { Store } from '@ngrx/store';
import { loadLanguageData } from 'src/app/state/actions';
import { selectLanguageData } from 'src/app/state/selectors';
import { selectAdvisorData, selectAdvisorError, selectAdvisorLoading } from 'src/app/state/selectors/advisors.selector';
import { loadBrokerConfigData } from 'src/app/state/actions/brokerConfig.actions';
import { selectBrokerConfigData } from 'src/app/state/selectors/brokerConfig.selector';
import { loadBrokerFormConfigData } from 'src/app/state/actions/brokerFormConfig.actions';
import { selectBrokerFormConfigData } from 'src/app/state/selectors/brokerFormConfig.selector';
declare var $: any;

@Component({
  selector: 'app-advisor-dashboard',
  templateUrl: './advisor-dashboard.component.html',
  styleUrls: ['./advisor-dashboard.component.css'],
  providers: [DatePipe, PhoneFormatPipe],
})
export class AdvisorDashboardComponent implements OnInit {
  adminName: any;
  public id: string;
  streetAddressline1: any;
  streetAddressline2: any;
  primaryPhone: any;
  secondaryPhone: any;
  primaryEmail: any;
  secondaryEmail: any;
  thirdEmail: any;
  country: any;
  city: any;
  state: any;
  provineList: any;
  postalCode: any;
  showaddadmin = true;
  showformtype = false;
  showaddform = false;
  addlicenseform = true;
  isEditable = true;
  enableEditIndex = null;
  todayDate: any;
  planLevels: any;
  uploadFormlogo: any;
  isEditableForm = true;
  enableEditIndexForm = null;
  brokersalesCodes: Array<any> = [];
  maxRemainderDays: number = 180;
  salesTrackingCode: any
  clickCount: number = 1;
  editbrokerEOinfo: any;
  editEOinsurerName: any;
  editEOpolicy: any;
  editEOcertificate: any;
  editEOExpiryDate: any;
  isEditableEO = true;
  enableEditIndexEO = null;
  showFormsDetails = true;
  shortNameValue: any;
  editFormType: any;
  editFormDetails: any;
  editFormName: any;
  brokerinfobrokerType: any;
  parentBrokerId: any;
  parentBrokerName: any;
  brokerinfoName: any;
  brokerid: any;
  editFormDescription: any;
  editFormlink: any;
  editFormlogo: any;
  editFormPricingOptions: any
  brokerlicensedetails: any
  editFormDisclousreAggrement: any;
  showparentdisclosurecondition = false;
  addlicenseformtable = false;
  addlicenseformData: Array<any> = [];
  addformDetails: Array<any> = [];
  productsArrayList: Array<any> = [];
  fromplansarry: Array<any> = [];
  editindex: any;
  groupContactId: any;
  groupAdminId: any;
  showimagelogo = true;
  showdisclosureaggrement = true;
  showparentlogocondition = false;
  imagedisplaypdf: any;
  disclosuredisplaypdf: any;
  termsAndConditionspdf: any;
  brokerlogo: any
  editbrokerlicensenumber: any;
  editbrokerlicensecoverage: any;
  editbrokerlicensestate: any;
  editbrokerlicenseexpirydate: any;
  editbrokerlicenseexpiryremainder: any;
  editSalesTrackingCode: any;
  editSalesTrackingName: any;
  editSalesTrackingType: any;
  editSalesTrackingPercentage: any;
  configprovinceres: any;
  enrollmentDates: any;
  imagedisplay: any;
  provincialHealthcareUrl: any;
  provincialZipcodes: any;
  SignupFormData: Array<any> = [];
  licensesInfo: Array<any> = [];
  EOinsurenceInfo: any;
  provincelistid: any;
  insurancestate_id: any;
  insurancestatename: any;
  licenseData: any;
  state_id: any;
  statename: any;
  serverUrl: any;
  public postalvalue: any;
  brokerData: Array<any> = [];
  allBrokers: Array<any> = [];
  licenseCoverage: Array<any> = [];
  brokerType: Array<any> = [];
  formType: Array<any> = [];
  uploaddisclousreAggrement: any;
  productsArray: Array<any> = [];
  advisorGroupContact: Array<any> = [];
  pricingOptions: Array<any> = [];
  uploadlogo: any;
  showBusinessnumber: boolean = false;
  customForm: boolean = false;
  public invalidpostalcodeprivince: boolean = false;
  public allplansArray: Array<any> = [];
  public plansIds = [];
  public showPlans: any;
  public plansError: boolean = false;
  public saveError: boolean = false
  swiper: Swiper;

  formTitle: any='';
  role = sessionStorage.getItem('role');
  formDescription: any
  showlicenseForm = false;
  showEOForm = false;
  brokerLicensedStatesAndProvinces: Array<any> = [];
  brokerLicensesGrouped: Array<any> = [];
  brokerHierarchy: Array<any> = [];
  brokerEOinformation: Array<any> = [];
  salesTrackingCodeShares: Array<any> = [];
  brokerFormData: Array<any> = [];
  brokerAdmins: Array<any> = [];
  globalbrokerFormData: Array<any> = [];
  brokerContactInfo: Array<any> = [];
  adminData: any;
  addadminform = false;
  brokerregform: FormGroup = new FormGroup({
    brokersName: new FormControl(''),
    brokerType: new FormControl(''),
    businessnumber: new FormControl(''),
    streetAddress: new FormControl(''),
    streetAddress2: new FormControl(''),
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
    primaryEmail: new FormControl(''),
    secondaryEmail: new FormControl(''),
    thirdEmail: new FormControl(''),
    country: new FormControl(''),
    city: new FormControl(''),
    Province: new FormControl(''),
    postalCode: new FormControl(''),
  });
  adminform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    phoneNum: new FormControl(''),
    email: new FormControl(''),
    role: new FormControl(''),
    roleName: new FormControl(''),
  });
  licenseform: FormGroup = new FormGroup({
    licenseNumber: new FormControl(''),
    licenseCoverage: new FormControl(''),
    state: new FormControl(''),
    expiryDate: new FormControl(''),
    remainder_days: new FormControl(''),
  });
  eoform: FormGroup = new FormGroup({
    insurerName: new FormControl(''),
    policyNumber: new FormControl(''),
    certificateNumber: new FormControl(''),
    expiryDate: new FormControl('')
  });


  formCreation: FormGroup = new FormGroup({
    Signupformtype: new FormControl(''),
    formName: new FormControl(''),
    formDescription: new FormControl(''),
    formlink: new FormControl(''),
    formlogo: new FormControl(''),
    formplanLevels: new FormControl(''),
    formdisclosureAgreement: new FormControl(''),
    pricingOptions: new FormControl('')

  });
  ShowOthers: boolean = false;
  prevSTC: any;
  groupContacts: Array<any> = [];
  corpId: any;
  brokerDetails: any;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any
  getResourcesFile: any;
  showresourcefile: boolean = false;
  showsoleAdvisorDataResult: any;
  resourceFileuplaod: string;
  disclosuredisplaypdf1: any;
  pdfvisibletermsandconditions: boolean = true;
  // changeDetector: any;
  loading$: Observable<boolean>;
  error$: Observable<string | null>;
  advisorData$: Observable<any>;
  brokerList: any = [];
  languageData$: Observable<any>;
  brokerConfigData$: Observable<any>;
  brokerConfigData: any = {}
  brokerFormConfigData$: Observable<any>;
  brokerFormConfigData: any = {}
  private destroy$ = new Subject<void>();
  showaddplans:boolean = false;
  showeditplans:boolean = false;
  selectedPlanLevels:any=[];

  constructor(private logger: LoggerService,
    public _LoaderService: LoaderService,
    public router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    public elementRef: ElementRef,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private _clipboardService: ClipboardService,
    private toastrService: ToastrService,
    private phoneNoFormat: PhoneFormatPipe,
    private elRef: ElementRef, private renderer: Renderer2,
    private commonPatternsService: CommonPatternsService,
    private store: Store<{ advisorData: [], languageData: [], brokerConfigData: {}, brokerFormConfigData: {} }>
  ) {
    this.advisorData$ = store.select(selectAdvisorData);
    this.loading$ = store.select(selectAdvisorLoading);
    this.error$ = store.select(selectAdvisorError);
    this.languageData$ = store.select(selectLanguageData);
    this.brokerConfigData$ = store.select(selectBrokerConfigData)
    this.brokerFormConfigData$ = store.select(selectBrokerFormConfigData)
   }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  ngOnInit() {

    // this.getLanguageTokens()

    this.corpId = this.route.snapshot.params['id']

    this.adminData = []
    this.serverUrl = environment.apiUrl
    this.todayDate = new Date()
    this.adminName = sessionStorage.getItem('adminName');


    this.dropdownList = [
      { item_id: 1, item_text: 'Mumbai' },
      { item_id: 2, item_text: 'Bangaluru' },
      { item_id: 3, item_text: 'Pune' },
      { item_id: 4, item_text: 'Navsari' },
      { item_id: 5, item_text: 'New Delhi' }
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.brokerregform = this.formBuilder.group({
      brokersName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(255),
        ],
      ],
      brokerType: [
        '',
        [
          Validators.required,
        ],
      ],
      businessnumber: [''],
      streetAddress: ['', [Validators.required]],
      streetAddress2: [''],
      primaryPhone: [
        '',
        [
          Validators.required,
          Validators.minLength(17),
          Validators.maxLength(17),
        ],
      ],
      secondaryPhone: [
        '',
        [
          Validators.minLength(17),
          Validators.maxLength(17),
        ],
      ],
      primaryEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonPatternsService.emailPattern),
        ],
      ],
      secondaryEmail: [
        '',
        [
          Validators.pattern(this.commonPatternsService.emailPattern),
        ],
      ],
      thirdEmail: [
        '',
        [
          Validators.pattern(this.commonPatternsService.emailPattern),
        ],
      ],
      country: ['', [Validators.required]],
      city: ['', [Validators.required, Validators.pattern(this.commonPatternsService.stringPattern),]],
      Province: ['', [Validators.required]],
      postalCode: ['', [Validators.required, Validators.compose([postalcodeValidator])]],
    });
    this.adminform = this.formBuilder.group({
      firstName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      phoneNum: [
        '',
        [
          Validators.required,
          Validators.minLength(17),
          Validators.maxLength(17),
        ],
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonPatternsService.emailPattern),
        ],
      ],
      role: ['', [Validators.required]],
      roleName: ['']
    });

    function maxRemainderDaysValidator(maxDays: number): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } | null => {
        const remainderDays = parseInt(control.value, 10);
        if (isNaN(remainderDays) || remainderDays > maxDays) {
          return { 'maxDaysExceeded': { value: control.value } };
        }
        return null;
      };
    }

    this.licenseform = this.formBuilder.group({
      licenseNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
        ],
      ],
      licenseCoverage: ['', [Validators.required]],
      state: ['', [Validators.required]],
      expiryDate: ['', [Validators.required]],
      remainder_days: ['', [Validators.required, maxRemainderDaysValidator(this.maxRemainderDays)]],
    });
    this.eoform = this.formBuilder.group({
      insurerName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
        ],
      ],
      policyNumber: ['', [Validators.required]],
      certificateNumber: ['', [Validators.required]],
      expiryDate: ['', [Validators.required]],
    });



    this.formCreation = this.formBuilder.group({
      Signupformtype: [''],
      formName: ['', [Validators.required]],
      formDescription: ['', [Validators.required]],
      formlink: [''],
      formlogo: [''],
      formplanLevels: [''],
      pricingOptions: ['']


    });

    this.id = this.route.snapshot.paramMap.get('id');

    // this.productsArray = [{ "id": "3", "name": "Classic Bronze" }, { "id": "4", "name": "Classic Silver" }, { "id": "7", "name": "All-In Bronze" }, { "id": "8", "name": "All-In Silver" }]



    this.formConfig()
    // this.getBrokerDetails()
    // this.getServiceWorkerDetails()

  }

  checkRole(event: any) {
    console.log(event.target.value)

  }
  getAdvisorsData(){
    this.store.dispatch(loadAdvisorData());
    this.advisorData$ = this.store.select(state => state.advisorData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.advisorData$.subscribe(data => {
      if (data) {
        console.log(data)
      if (data?.advisorData == undefined || Object.keys(data.advisorData).length <= 0) {
        console.log('No data to process', new Date().toISOString());
        return;
      }
      if(this.brokerList.length>0){
        return;
      }
      this.brokerList = data.advisorData
      this.brokerList = this.brokerList.map((broker)=>{
        return{
          ...broker,
          published: !broker.published || broker.published == undefined || broker.published == null ? 'Inactive' : 'Active'
        }
      })
      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "advisorDashboard"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       console.log(response)
    //       this.lang = {};
    //       this.languageData = response.strings
    //       this.selectedLanguage = sessionStorage.getItem("language")
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }
    //     })

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if(data){
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(()=>{
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        },0)
      }
    })

  }
  // handleEditAdv() {
  //   this.brokerregform.reset();
  // }

  replaceUnderScores(str) {
    str = str.toLowerCase();
    return str.replace(/_/g, ' ');
  }
  customizeCoverage(str) {
    str = str.toLowerCase().replace(/_/g, ' ');
    if (str.includes('life accident')) {
      return 'Both(Life, Accident and Sickness)'
    } else {
      let words = str.split(' ');
      for (let i = 0; i < words.length; i++) {
        words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
      }
      return words.join(' ');
    }
  }

  disableScrolling(): void {
    const container = this.elRef.nativeElement.querySelector('.form-container');
    if (container) {
      this.renderer.setStyle(container, 'overflow-y', 'hidden');
    }
  }

  enableScrolling(): void {
    const container = this.elRef.nativeElement.querySelector('.form-container');
    if (container) {
      this.renderer.setStyle(container, 'overflow-y', 'auto');
    }
  }



  // getServiceWorkerDetails() {
  //   var GetBrokersDetails = '/api/ap/broker/' + this.route.snapshot.params['id'] + '/details';


  //   let prefetchurls = []

  //   let Data = [{
  //     url: environment.apiUrl + GetBrokersDetails,
  //     // fetch options
  //     options: {

  //       mode: 'cors',
  //       headers: {

  //         Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //         'Content-Type': 'application/json',
  //       }
  //     }
  //   }]
  //   prefetchurls = Data

  //   postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {


  //     this.brokerEOinformation = []
  //     let response = results[0].response

  //     let licenseData = response.data.brokerLicensedStatesAndProvinces


  //     for (let i = 0; i < licenseData.length; i++) {

  //       licenseData[i].expiryDate = this.datePipe.transform(
  //         licenseData[i].expiryDate,
  //         'MMM-dd-yyyy'
  //       )
  //     }

  //     if (licenseData.length == 0) {
  //       this.showlicenseForm = true
  //     }
  //     else {
  //       this.showlicenseForm = false
  //     }

  //     let licenseEO = response.data.brokerEoInsurance

  //     const isObjectEmpty = (objectName) => {
  //       return Object.keys(objectName).length === 0
  //     }


  //     if (isObjectEmpty(licenseEO) == true) {
  //       this.showEOForm = true
  //     }
  //     else {
  //       this.showEOForm = false
  //     }


  //     licenseEO['expiryDate'] = this.datePipe.transform(
  //       response.data.brokerEoInsurance.expiryDate,
  //       'MMM-dd-yyyy'

  //     )

  //     this.salesTrackingCodeShares = response.data.salesTrackingCodeShares
  //     this.brokerEOinformation.push(licenseEO)



  //     this.brokerLicensedStatesAndProvinces = licenseData

  //     this.brokerFormData = response.data.signupForms ?? [];

  //     this.logger.log("gettingBrokerData")
  //     this.logger.log("gettingBrokerData " + this.brokerFormData.length)
  //     this.logger.log("formsData", this.brokerFormData)

  //     this.parentBrokerId = response.data.parentId
  //     this.parentBrokerName = response.data.parent.name
  //     this.logger.log(this.parentBrokerName, "name")
  //     this.globalbrokerFormData = response.data.signupForms ?? []

  //     this.adminData = response.data.brokerAdmins;
  //     this.logger.log(this.adminData, "response")

  //     if (this.adminData.length > 0) {
  //       this.addadminform = false
  //       this.showaddadmin = true
  //     }
  //     else {
  //       this.addadminform = true
  //       this.showaddadmin = false
  //     }


  //     this.brokerContactInfo.push(response.data.contactInfo ? response.data.contactInfo : '')

  //     this.streetAddressline1 = this.brokerContactInfo[0].line1
  //     this.streetAddressline2 = this.brokerContactInfo[0].line2
  //     this.primaryPhone = this.brokerContactInfo[0].primaryPhone
  //     this.secondaryPhone = this.brokerContactInfo[0].secondaryPhone
  //     this.primaryEmail = this.brokerContactInfo[0].primaryEmail
  //     this.secondaryEmail = this.brokerContactInfo[0].secondaryEmail.split(",")[0]
  //     if (this.brokerContactInfo[0].secondaryEmail.split(",") > 1) {
  //       this.thirdEmail = this.brokerContactInfo[0].secondaryEmail.split(",")[1]
  //     }
  //     this.country = this.brokerContactInfo[0].country
  //     this.city = this.brokerContactInfo[0].city
  //     this.state = this.brokerContactInfo[0].state
  //     this.postalCode = this.brokerContactInfo[0].postalCode
  //     this.brokerinfobrokerType = response.data.brokerType

  //     this.brokerinfoName = response.data.name

  //     this.brokerid = response.data.id

  //     this.logger.log(this.brokerLicensedStatesAndProvinces)
  //     if (this.brokerFormData && this.brokerFormData.length > 0) {
  //       this.showFormsDetails = true;
  //       this.showaddform = false;
  //     }
  //     else {
  //       this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
  //       this.showFormsDetails = false
  //       this.showaddform = true;
  //       this.showPlans = true;
  //     }



  //   })
  // }


  getBrokerNames(sales) {
    return sales.salesTrackingCode.salesTrackingCodeShares
      .map(salesdata => salesdata.broker.name)
  }


  getBrokerTypes(sales) {
    return sales.salesTrackingCode.salesTrackingCodeShares
      .map(salesdata => salesdata.broker.brokerType)
      .join(', ');
  }


  copyToClipboard1(link) {
    const button = document.getElementById("copyButton1") as HTMLButtonElement;
    if (button) {
      button.disabled = true;
      button.style.color = 'white';
      setTimeout(() => {
        button.disabled = false;
      }, 2000);
    }

    const clipboard = new ClipboardJS('#copyButton1', {
      text: () => link
    });

    clipboard.on('success', (e) => {
      console.log(`Link was copied to the clipboard`);
      e.clearSelection();
    });

    clipboard.on(this.lang.Error??'Error', (e) => {
      console.error('Unable to copy text to clipboard', e);
    });



    Swal.fire({
      text: 'Link Copied',
      // icon: this.lang.Info,
      timer: 1500, // Set the timer to 3000 milliseconds (3 seconds)
      showConfirmButton: false, // Hide the "OK" button
      width: 270
    });


  }


  getBrokerPercentages(sales) {
    return sales.salesTrackingCode.salesTrackingCodeShares
      .map(salesdata => salesdata.percentage)
  }


  transformText(str) {
    return str.toLowerCase();
  }



  rightClick() {
    if (this.clickCount < this.groupContacts.length) {
      this.clickCount += 1;
    } else {
      this.clickCount = 1
    }
    const admin = this.groupContacts[this.clickCount - 1];
    console.log(admin, this.clickCount, 'asd')
    this.adminform.patchValue(admin)

  }


  leftClick() {
    if (this.clickCount > 1) {
      this.clickCount -= 1;
    } else {
      this.clickCount = this.groupContacts.length;
    }
    const admin = this.groupContacts[this.clickCount - 1];

    this.adminform.patchValue(admin)

  }



  getcoverflow() {
    var TrandingSlider = new Swiper('.tranding-slider', {
      effect: 'coverflow',
      centeredSlides: true,
      loop: true,
      slidesPerView: 'auto',
      allowTouchMove: false,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2.5,
      },
      pagination: {
        el: '.swiper-pagination',
        type: "fraction"
      },
      navigation: {
        nextEl: '.swiper-button-next2',
        prevEl: '.swiper-button-prev2',
      },
      on: {

        slideChangeTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
          let $wrapperEl = swiper.$wrapperEl;
          let params = swiper.params;
          $wrapperEl.children(('.' + (params.slideClass) + '.' + (params.slideDuplicateClass)))
            .each(function () {
              let idx = this.getAttribute('data-swiper-slide-index');
              this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html();
            });
        },

        slideChangeTransitionEnd: function (swiper) {
          swiper.update();
          swiper.pagination.update();
          swiper.slideToLoop(swiper.realIndex, 0, false);
        },
        slideNextTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        },
        slidePrevTransitionStart: function (swiper) {
          swiper.update();
          swiper.pagination.update();
        }


      }
    });


    // setTimeout(()=>{
    //   that.swiper.loopDestroy();
    //   this.swiper.loopCreate();
    //   console.log('reborn!')
    //   })

    // console.log(TrandingSlider.activeIndex)
  }
businessNumber: string = '';

  getBrokerDetails() {

    this.brokerEOinformation = []
    this.logger.log(this.route.snapshot.params['id'])
    // let broker= broker.id
    var accessToken = sessionStorage.getItem('accessToken');
    // var GetBrokersDetails = '/api/ap/broker/' + this.route.snapshot.params['id'] + '/details';
    // var GetBrokersDetails = 'http://[::1]:3002/api/ap/broker/' + this.route.snapshot.params['id'] + '/details/first';
    var GetBrokersDetails = '/api/ap/broker/' + this.route.snapshot.params['id'] + '/details/first';

    this.http
      .get(environment.apiUrl + GetBrokersDetails, {
        // .get(GetBrokersDetails, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          this.logger.log(response)
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.logger.log(response)
            this.getAdvisorsData()
            this.getLanguageTokens()

            setTimeout(() => {
              this.getcoverflow();
            }, 2000);

            this.showsoleAdvisorDataResult = response.data
            let licenseData = response.data.brokerLicensedStatesAndProvinces
            let groupedLicenseData = response.data.brokerLicensesGrouped
            let hierarchy = response.data.brokerHierarchy
            this.disclosuredisplaypdf = response.data.disclosureAgreement
            this.termsAndConditionspdf = response.data.termsAndConditions
            this.brokerlogo = response.data.logo
            this.brokerHierarchy = hierarchy
            // this.logger.log('brokerHierarchy',this.brokerHierarchy);

            for (let i = 0; i < licenseData.length; i++) {
              licenseData[i].expiryDate = this.datePipe.transform(
                licenseData[i].expiryDate,
                'MM-dd-yyyy'
              )
            }

            if (licenseData.length == 0) {
              this.showlicenseForm = true
            }
            else {
              this.showlicenseForm = false
            }

            let licenseEO = response.data.brokerEoInsurance

            const isObjectEmpty = (objectName) => {
              return Object.keys(objectName).length === 0
            }


            if (isObjectEmpty(licenseEO) == true) {
              this.showEOForm = true
            }
            else {
              this.showEOForm = false
            }

            if (response.data.brokerEoInsurance.expiryDate) {
              licenseEO['expiryDate'] = this.datePipe.transform(
                response.data.brokerEoInsurance.expiryDate,
                'MM-dd-yyyy'
              )
            }

            this.salesTrackingCodeShares = response.data.salesTrackingCodeShares
            this.logger.log('salesTrackingCodeShares', this.salesTrackingCodeShares)
            if (isObjectEmpty(licenseEO) == false && this.brokerEOinformation.length == 0) {
              this.brokerEOinformation.push(licenseEO)
            }



            this.brokerLicensedStatesAndProvinces = licenseData
            this.brokerLicensesGrouped = groupedLicenseData
            // this.logger.log("groupedLicenseData", this.brokerLicensesGrouped[0].licenses)

            this.brokerList = this.brokerList.map(broker =>
              broker.id == this.brokerid ? { ...broker, license: { count:this.brokerLicensesGrouped?.length ?? 0 } } : broker
            );
            this.store.dispatch(loadAdvisorDataSuccess({advisorData:this.brokerList}))

            this.brokerFormData = response?.data?.signupForms ?? response?.data?.forms ?? [];
            this.groupContacts = response.data.brokerAdmins ?? [];

            this.logger.log("gettingBrokerData")
            this.logger.log("gettingBrokerData " + this.brokerFormData.length)
            this.logger.log("formsData", this.brokerFormData)

            this.parentBrokerId = response.data.parentId
            this.parentBrokerName = response.data.parent?.name
            this.logger.log('parentBrokerName', this.parentBrokerName)

            this.globalbrokerFormData = response?.data?.signupForms ?? response?.data?.forms ?? []

            this.adminData = response.data.brokerAdmins;
            this.logger.log(this.adminData, "response")

            if (this.adminData.length > 0) {
              this.addadminform = false
              this.showaddadmin = true
            }
            else {
              this.addadminform = true
              this.showaddadmin = false
            }

            this.brokerDetails = response.data.contactInfo


            this.brokerContactInfo.push(response.data.contactInfo ? response.data.contactInfo : '')

            this.streetAddressline1 = this.brokerContactInfo[0].line1
            this.streetAddressline2 = this.brokerContactInfo[0].line2
            this.primaryPhone = this.brokerContactInfo[0].primaryPhone
            this.secondaryPhone = this.brokerContactInfo[0].secondaryPhone
            this.primaryEmail = this.brokerContactInfo[0].primaryEmail
            this.secondaryEmail = this.brokerContactInfo[0].secondaryEmail?.split(",")[0]
            if (this.brokerContactInfo[0].secondaryEmail?.split(",").length > 1) {
              this.thirdEmail = this.brokerContactInfo[0].secondaryEmail?.split(",")[1]
            }
            this.country = this.brokerContactInfo[0].country;
            this.changeCountry();
            this.city = this.brokerContactInfo[0].city
            this.state = this.brokerContactInfo[0].state
            this.postalCode = this.brokerContactInfo[0].postalCode
            this.brokerinfobrokerType = response.data.brokerType
            this.businessNumber = response.data.uniqueId ?? '';  

            this.brokerinfoName = response.data.name

            this.brokerid = response.data.id

            this.logger.log(this.brokerLicensedStatesAndProvinces)
            if (this.brokerFormData && this.brokerFormData.length > 0) {
              this.showFormsDetails = true;
              this.showaddform = false;
            }
            else {
              this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
              sessionStorage.setItem('editFormType','CUSTOM')
              this.showFormsDetails = false
              this.showaddform = true;
              this.showPlans = true;
            }
            // this.getBrokerDetailsRest()

          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
          this.cdr.markForCheck();

        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'OK',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  getBrokerDetailsRest() {
    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokersDetails = '/api/ap/broker/' + this.route.snapshot.params['id'] + '/details/rest';
    // var GetBrokersDetails = 'http://[::1]:3002/api/ap/broker/' + this.route.snapshot.params['id'] + '/details/rest';

    this.http
      .get(environment.apiUrl + GetBrokersDetails, {
      // .get(GetBrokersDetails, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          this.logger.log(response)
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.logger.log(response)

          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
          this.cdr.markForCheck();

        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'OK',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }
  downloadResource(value: any) {
    console.log(environment.apiUrl + "/api/ap/" + value)
    this.http.get(environment.apiUrl +"/api/ap/"+value, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = environment.apiUrl + "/api/ap/" + value;
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Error, text: error.error.error.message })
      }
    );
  }
  DisclosureagreementLoaded() {
    this.pdfvisibletermsandconditions = false

  }

  checkformExist() {
    let addvisorformtitle = this.formCreation.value.formName;
    let accessToken = sessionStorage.getItem('accessToken');
    //localhost:3002/api/ap/admin/corporate/checkCorporateName'
    let endPoint = `/api/ap/broker/checkFormTitle`;
    let inputData = {

      "name": addvisorformtitle,
      "brokerId": this.brokerid
    }
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == '200') {//new corporate
        return false;
      }
      else {//Already exist
        Swal.fire({ title: this.lang.Info, text: response.message }).then((result) => {

        });
      }
    }, (error) => {
      Swal.fire({ title: this.lang.Error??'Error', text: error.message ?? error.error.message })
    })
  }
  groupContactChange(event: any) {
    if (event.target.value == 'ADVISOR_OTHERS') {
      this.ShowOthers = true;
      this.adminform.get('roleName').setValidators(Validators.required);
    }
    else {
      this.ShowOthers = false;
      this.adminform.get('roleName').clearValidators();
    }
    this.adminform.get('roleName').updateValueAndValidity();
  }


  editAdvisor() {

    this.brokerDetails.secondaryEmail = this.brokerContactInfo[0].secondaryEmail.split(",")[0]
    if (this.brokerContactInfo[0].secondaryEmail.split(",").length > 1) {
      this.brokerDetails.thirdEmail = this.brokerContactInfo[0].secondaryEmail.split(",")[1]
    }
    this.state = this.brokerDetails.state
    this.brokerregform.patchValue(this.brokerDetails)
    this.changeCountry()
  }

  editCorporate() {
    this.router.navigate([`manageAdvisors/editAdvisor/${this.corpId}`])
  }

  get broker() {
    return this.brokerregform.controls;
  }
  get f() {
    return this.licenseform.controls;
  }
  get form() {
    return this.formCreation.controls;
  }
  get eo() {
    return this.eoform.controls;
  }
  get grpcontact() {
    return this.adminform.controls;
  }

  clearAdminForm() {
    this.adminform.reset();
  }
  addadmin() {
    if (this.ShowOthers) {
      this.grpcontact['roleName'].markAsTouched();
    }
    if (this.adminform.invalid) {
      this.logger.log(this.adminform);
      return;
    }
    this.logger.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = {
      firstName: this.capitalize(this.adminform.value.firstName),
      lastName: this.capitalize(this.adminform.value.lastName),
      phoneNum: this.adminform.value.phoneNum,
      email: this.adminform.value.email,
      role: this.adminform.value.role,
      id: this.brokerid,
      roleName: '' //this.adminform.value.role=='ADVISOR_OTHERS'?this.adminform.value.roleName:"",

    };
    if (obj.role == 'ADVISOR_OTHERS') {
      obj['roleName'] = this.adminform.value.roleName ?? '';
    } else {
      obj['roleName'] = '';
    }


    this.adminData.push(obj);
    this.logger.log(this.adminData, "admindata")
    // if(obj.role=='ADVISOR_OTHERS')
    // obj['roleName']=this.adminform.value.roleName;
    // this.adminData.push(obj);

    this.adminform.reset();

    this.showaddadmin = true;
    this.addadminform = false;
    this.ShowOthers = false;

    $('#basicModal1').modal('hide');




    var addBrokerDetails = '/api/ap/v2/broker/' + this.brokerid + '/groupContact';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .post(environment.apiUrl + addBrokerDetails, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            Swal.fire({ title: this.lang.Info, text: response.message })

            this.getBrokerDetails()

            // this.getServiceWorkerDetails()
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
            this.getBrokerDetails()
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
        })



  }
  deleteadmin(admin, index: any) {

    if (this.groupContacts.length > 1) {

      Swal.fire({
        title: this.lang.Alert,
        text: this.lang.Are_you_sure_you_want_to_delete_this_Group_Contact + "?",
        showDenyButton: false,
        showCancelButton: true,
        cancelButtonText: this.lang.Cancel,
        confirmButtonText: this.lang.Proceed,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          // const Data = this.adminData;
          // const removed = Data.splice(index, 1);


          var deletebroker = '/api/ap/broker/' + this.brokerid + '/groupContact/' + admin.userId + '';
          var accessToken = sessionStorage.getItem('accessToken');

          this.http
            .delete(environment.apiUrl + deletebroker, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200 || response['statusCode'] == 200) {

                  this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                    this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                      "message": "Advisors information has been updated. Please refresh screen."
                    }, {
                      headers: {
                        Authorization: 'Bearer ' + accessToken,
                        'Content-Type': 'application/json',
                      }
                    }).subscribe((res) => {
                      console.log({ res })
                    })
                  })

                  this.getBrokerDetails()
                  // this.getServiceWorkerDetails()
                } else {
                  Swal.fire({ title: this.lang.Error??'Error', text: response.message })
                }
              },
              (error) => {
                if (
                  error.status == 400 ||
                  error.status == 401 ||
                  error.status == 402 ||
                  error.status == 403
                ) {
                  Swal.fire({
                    title: this.lang.Error??'Error',
                    text: error.error.error.message,
                    showDenyButton: false,
                    showCancelButton: false,
                    cancelButtonText: this.lang.Cancel,
                    confirmButtonText: 'Ok',
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    }
                    else {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    }
                  });
                } else {
                  // Swal.fire(error.error.error.message)
                  Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
                }
              })

          if (this.adminData.length == 0) {
            this.addadminform = true;
            this.showaddadmin = false;
          }
          else {
            this.addadminform = false;
            this.showaddadmin = true;
          }



        }
      })
    }

  }

  editadmin(admin: any, index: any) {
    this.logger.log(this.adminform)
    this.logger.log(admin)
    this.ShowOthers = admin.role == "ADVISOR_OTHERS" ? true : false;
    this.adminform.patchValue(admin)

    this.logger.log(this.adminform)
    this.editindex = index;
    this.groupContactId = admin.userId
    this.groupAdminId = admin.groupAdminId
  }
  editadminSubmit(admin) {
    this.logger.log({ admin })
    if (this.ShowOthers) {
      this.grpcontact['roleName'].markAsTouched();
    }

    if (this.adminform.invalid && this.adminform.get('phoneNum')?.value != '') {
      this.logger.log(this.adminform);
      return;
    }
    this.logger.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = { ...this.adminform.value }
    this.adminData[this.editindex] = this.adminform.value;
    obj['brokerAdminId'] = this.groupAdminId
    this.logger.log(obj)

    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    $('#basicModaledit').modal('hide');
    var editbroker = '/api/ap/v2/broker/' + this.brokerid + '/groupContact/' + this.groupContactId + '';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .put(environment.apiUrl + editbroker, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            Swal.fire({ title: this.lang.Info, text: response.message })

            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })

            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
        })
    // $('#basicModal1').modal('hide');
  }
  hidegrpadmindetails() {
    this.adminform.reset();
  }

  hidelicensedetails() {
    this.licenseform.reset();
  }
  saveLicense(license: any, index: number) {


    this.logger.log(this.brokerLicensedStatesAndProvinces[index])

    //     this.logger.log(license)


    var accessToken = sessionStorage.getItem('accessToken');
    var saveAdvisorlicense = '/api/ap/broker/' + license.brokerId + '/license/' + license.id + '';


    let licenseData = this.brokerLicensedStatesAndProvinces[index]

    this.logger.log(this.insurancestate_id)
    this.logger.log(this.insurancestatename)
    this.logger.log(this.brokerLicensedStatesAndProvinces[index].expiryDate)
    this.logger.log(this.datePipe.transform(this.brokerLicensedStatesAndProvinces[index].expiryDate, 'yyyy-MM-dd'))
    // this.logger.log(this.datePipe.transform(date,"yyyy-MM-dd")); //output : 2018-02-13

    let Data =
    {
      "provinces_id": this.insurancestate_id || this.brokerLicensedStatesAndProvinces[index].stateId,
      "provinces_name": this.insurancestatename || this.brokerLicensedStatesAndProvinces[index].stateFullDetails.name,
      "expiry_date": this.datePipe.transform(this.brokerLicensedStatesAndProvinces[index].expiryDate, 'yyyy-MM-dd') || '',
      "reminder_email": parseInt(licenseData.reminderEmail),
      "license_num": licenseData.licenseNumber,
      "license_coverage": licenseData.licenseCoverage
    }


    this.logger.log(Data)
    this.http
      .put(environment.apiUrl + saveAdvisorlicense, Data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.isEditable = true;
            this.enableEditIndex = null
            this.insurancestate_id = null
            this.insurancestatename = null
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

  }

  phoneFormatForGroupCont(form: FormGroup, id: any) {
    const inputValue = form.get(id).value;
    //this.adminform.controls
    form.get(id).
      setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }
  public getprovinceshortName(event: any) {

    this.configprovinceres.forEach((element: any) => {

      // this.logger.log(element.shortName)
      // this.logger.log(event)
      if (element.shortName == event) {

        this.shortNameValue = element.shortName
      }
    });
  }
  convertDate(dateStr: any) {
    const date = new Date(dateStr);

    // Get month, day, and year
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    // Form the MM-DD-YYYY format
    const formattedDate = `${month}-${day}-${year}`;
    return formattedDate
  }
  editLicenseSubmit() {

    if (this.licenseform.invalid) {
      this.logger.log(this.licenseform);
      return;
    }

    this.getprovinceshortName(this.licenseform.value.state)

    var accessToken = sessionStorage.getItem('accessToken');
    var saveAdvisorlicense = '/api/ap/broker/' + this.brokerlicensedetails.brokerId + '/license/' + this.brokerlicensedetails.id + '';



    let Data =
    {
      "provinces_id": this.insurancestate_id || this.brokerlicensedetails.stateId,
      "provinces_name": this.insurancestatename || this.brokerlicensedetails.stateFullDetails.name,
      "expiry_date": moment(this.licenseform.value.expiryDate, "MMM-DD-YYYY").format("MMM-DD-YYYY"),
      "reminder_email": parseInt(this.licenseform.value.remainder_days),
      "license_num": this.licenseform.value.licenseNumber,
      "license_coverage": this.licenseform.value.licenseCoverage,
      "provinceshortName": this.shortNameValue
    }


    this.logger.log(Data)
    this.http
      .put(environment.apiUrl + saveAdvisorlicense, Data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          this.licenseform.reset();
          if (response['status'] == 200 || response['statusCode'] == 200) {
            Swal.fire({ title: this.lang.Info, text: response.message })
            this.isEditable = true;
            this.enableEditIndex = null
            this.insurancestate_id = ''
            this.insurancestatename = ''
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })

            // this.brokerContactInfo =[]
            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
            $('#licenseedit').modal('hide');
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

  }
  editeoinfosumbit() {
    if (this.eoform.invalid) {
      this.eoform.markAllAsTouched();
      this.logger.log(this.eoform);
      return;
    }
    this.logger.log(this.eoform)


    var accessToken = sessionStorage.getItem('accessToken');
    var updateLicenseEO = '/api/ap/broker/' + this.editbrokerEOinfo.brokerId + '/updateLicenceEO';

    let data = {
      "certificateNumber": this.eoform.value.certificateNumber,
      "expiryDate": moment(this.eoform.value.expiryDate, "MMM-DD-YYYY").format("MMM-DD-YYYY"),
      "insurerName": this.capitalize(this.eoform.value.insurerName),
      "policyNumber": this.eoform.value.policyNumber
    }
    this.http
      .put(environment.apiUrl + updateLicenseEO, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            Swal.fire({ title: this.lang.Info, text: response.message })
            this.getBrokerDetails()

            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            //this.getServiceWorkerDetails()
            $('#basicModaleditEO').modal('hide');
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  saveEOInfo(broker: any, index: number) {



    var accessToken = sessionStorage.getItem('accessToken');
    var updateLicenseEO = '/api/ap/broker/' + broker.brokerId + '/updateLicenceEO';

    let EOData = this.brokerEOinformation[index]
    let data = {
      "certificateNumber": EOData.certificateNumber,
      "expiryDate": this.datePipe.transform(
        EOData.expiryDate,
        'MMM-dd-yyy'
      ) || '',
      "insurerName": this.capitalize(EOData.insurerName),
      "policyNumber": EOData.policyNumber
    }

    this.logger.log(data)

    this.http
      .put(environment.apiUrl + updateLicenseEO, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        async (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.isEditableEO = true;
            this.enableEditIndexEO = null
            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //   environment.apiUrl + updateLicenseEO
            // ]);
            // this.brokerEOinformation = []
            this.getBrokerDetails()

            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            //this.getServiceWorkerDetails()
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

  }

  ngAfterViewInit() {
    // this.message = 'all done loading :)'
  }

  editadvisorlicenseDetails(e, i, broker) {
    // this.isEditable =false;
    // this.enableEditIndex = i;
    // this.logger.log(i, e);

    this.logger.log(broker)
    this.brokerlicensedetails = broker
    // this.editindex = i;
    this.editbrokerlicensenumber = broker?.licenseNumber;
    this.editbrokerlicensecoverage = broker?.licenseCoverage;
    this.editbrokerlicensestate = broker?.stateFullDetails?.shortName;
    this.editbrokerlicenseexpirydate = this.datePipe?.transform(broker?.expiryDate, "MM-dd-yyyy") || "";
    // this.editbrokerlicenseexpirydate = broker.expiryDate
    this.editbrokerlicenseexpiryremainder = broker?.reminderEmail;
    // this.editbrokerlicenseshortName = broker.provinceshortName

    this.cdr.detectChanges();

  }

  addRow() {
    this.brokersalesCodes.push({
      brokerId: '',
      percentage: '',
    });
  }

  deleteRow(index: number, dynamic: any) {

    if (this.brokersalesCodes.length == 1) {
      Swal.fire({
        title: this.lang.Warning,
        text: this.lang.Can_t_delete_the_row_when_there_is_only_one_row,
      });
      return false;
    } else {
      Swal.fire({
        title: this.lang.Info,
        text: this.lang.Are_you_sure_you_want_to_delete + "?",
        showDenyButton: false,
        showCancelButton: true,
        cancelButtonText: this.lang.Cancel,
        confirmButtonText: this.lang.Proceed,
      }).then((result) => {
        if (result.isConfirmed) {
          this.brokersalesCodes.splice(index, 1);
          // Swal.fire({ title: this.lang.Info, text: "Deleted Successfully" })

        }
      })

    }
  }

  editSaleslTrackingCode(e, i, broker) {
    this.logger.log(broker)
    this.salesTrackingCode = broker.salesTrackingCode.code
    broker.salesTrackingCode.salesTrackingCodeShares.forEach((b, i) => {
      this.brokersalesCodes.push({
        brokerId: b.brokerId,
        percentage: b.percentage,
      })
    })


  }



  saveEditSalesTrackingCodes() {

    var accessToken = sessionStorage.getItem('accessToken');
    var saveAdvisorlicense = '/api/ap/broker/salesTrackingCode/commisions';
    const convert = this.brokersalesCodes.map((b) => {
      return {
        brokerId: Number(b.brokerId),
        percentage: Number(b.percentage)
      }
    })
    this.logger.log({ convert })
    const obj = {
      code: this.salesTrackingCode,
      salesTrackingCodeShares: [...convert]
    }
    this.http
      .put(environment.apiUrl + saveAdvisorlicense, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            Swal.fire({ title: this.lang.Info, text: response?.message })

            $('#salesTrackingEdit').modal('hide');
            this.brokersalesCodes = []
            this.salesTrackingCode = ''
            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response?.message })
          }
        },
        (error) => {
          this.logger.log(error.error.message)
          if (error.error.status == 422) {
            this.logger.log(error.error.message)

            Swal.fire({
              title: this.lang.Error??'Error', text: error.error.message, showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            })
            // Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message })
            // Swal.fire({ title: this.lang.Error??'Error', text: "ok" })
          }
          else if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
        }
      );



  }

  closeEditSalesTrackingCodes() {
    this.logger.log(this.brokersalesCodes)
    this.brokersalesCodes = []
  }

  editadvisorEODetails(e, i, broker) {

    this.logger.log(broker)

    this.editindex = i;

    this.editbrokerEOinfo = broker
    this.editEOinsurerName = broker.insurerName;
    this.editEOpolicy = broker.policyNumber;
    this.editEOcertificate = broker.certificateNumber;
    this.editEOExpiryDate = broker.expiryDate;
  }

  public isParentsGreaterThanOne(groups: any): boolean {
    // this.logger.log(Object.keys(groups), Object.keys(groups).length > 1)
    return groups && Object.keys(groups).length > 1;
  }

  public showPricing = false;


  getStatus(published, restricted) {
    let data = -1;
    if (published) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
      }

    }
    else {
      data = 0
    }
    return data
  }

  public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }

  getColorForPlans(published, restricted) {

    const pubStatus = { 0: false, 1: true }
    // console.log(pubStatus[published], restricted)
    let data = this.getStatus(pubStatus[published], restricted)
    return this.colors[data]
  }

  getTextForTooltip(published, restricted) {
    const pubStatus = { 0: false, 1: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }

  getColorForPlans1(published, restricted) {

    let data: any = this.getStatus(published, restricted)
    const color = this.colors[data];
    return color;
  }

  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]

    // console.log(text)
    return text
  }

  public isGroupsNotEmpty(groups: any): boolean {

    return groups && Object.keys(groups).length > 0;
  }
  initializePlansArray(pArray: any, checked: boolean, disabled: boolean, type?: string,) {
    this.allplansArray = []

    pArray.forEach(product => {
      let obj = {
        packageCheckbox: type === 'EXECUTIVE' && product.name === 'Private Health' ? true : checked,
        packageId: product.id,
        packageName: product.name,
        disabled: disabled,

      };


      Object.keys(product.parents).forEach((plan: any) => {
        product.parents[plan].forEach((p) => {

          obj[p.name] = {
            planCheckbox: type === 'EXECUTIVE' && product.name === 'Private Health' ? true : checked,
            planId: p.id,
            parentId: p.parentId,
            planName: p.name,
            disabled: disabled,

          };
          obj[plan] = {
            checked: checked,
            disabled: disabled,
            isParent: true,
            id: p.parentId || ""
          }
        }
        )

      });


      this.allplansArray[product.name] = obj
    });
    this.logger.log({ plansArray: this.allplansArray })
  }

  changePackageCheckedValues(productName: any, productId: any, bool: boolean) {
    this.allplansArray[productName]['packageCheckbox'] = bool;
    Object.keys(this.allplansArray[productName]).forEach((p, id) => {
      if (typeof this.allplansArray[productName][p] === 'object') {
        this.allplansArray[productName][p]['planCheckbox'] = bool;
      }
    })

    Object.keys(this.allplansArray[productName]).forEach((p, id) => {
      if (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p].isParent) {
        this.allplansArray[productName][p].checked = bool;
      }
    })
    this.logger.log({ plansArray: this.allplansArray })

  }


  checkForClassic() {
    let flag = 0

    Object.keys(this.allplansArray).forEach((pack: any) => {
      if (this.allplansArray[pack].packageId == 1) {
        Object.keys(this.allplansArray[pack]).forEach((p) => {
          if (typeof this.allplansArray[pack][p] === 'object' && p.includes("Classic") && this.allplansArray[pack][p]['parentId'] && this.allplansArray[pack][p]['planCheckbox'] === true) {
            flag = flag + 1
          }
        });
      }
    });

    if (flag >= 1) {
      this.showPricing = true;
    }
    else {
      this.showPricing = false;
    }
  }

  toggleAllPlans(productName: any, productId: any, event: any) {
    this.logger.log(productName, productId, event.target.checked)

    if (event.target.checked) {
      this.plansError = false;
      this.changePackageCheckedValues(productName, productId, true)

    }
    else {
      this.changePackageCheckedValues(productName, productId, false)

    }

    this.logger.log({ plansArray: this.allplansArray })

    this.checkForClassic()


  }

  checkForAllPlansChecked(productName, planKey: any, parentId) {

    let planFlag = Object.keys(this.allplansArray[productName]).some((p) => {
      return (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p]['parentId'] === parentId && this.allplansArray[productName][p]['planCheckbox'] === false)
    });
    this.allplansArray[productName][planKey].checked = !planFlag;


    let flag = Object.keys(this.allplansArray[productName]).some((p) => {
      return (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p]['parentId'] != 'null' && this.allplansArray[productName][p]['planCheckbox'] === false)
    });


    this.allplansArray[productName].packageCheckbox = !flag;


    this.logger.log({ plansAyyay: this.allplansArray })
  }

  changePlanCheckedValues(productName: any, planKey: any, parentId: any) {
    this.allplansArray[productName].packageCheckbox = false;
    this.allplansArray[productName][planKey].checked = false;
    this.checkForAllPlansChecked(productName, planKey, parentId)
    this.checkForClassic()

  }

  planCheckbox(productName: any, planKey: any, parentId: any, planName: any, planId: any, event: any, disallowedPlanLevels: any, allowmultiple: any) {
    let disabled = true
    console.log(planId)
    console.log(disallowedPlanLevels)
    console.log(allowmultiple)

    if (event.target.checked) {
      this.plansError = false
      this.allplansArray[productName][planName].planCheckbox = true;
      this.changePlanCheckedValues(productName, planKey, parentId)

      if (disallowedPlanLevels != null) {

        let disallowed_plans = disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#planCheckbox${disallowed_plans[i]}`)

            if (elem != null) {
              if (!elem.disabled) {

                elem.disabled = true
              }
            }
          }, 100);

        }
      }
    }
    else {

      if (disallowedPlanLevels != null) {

        let disallowed_plans = disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#planCheckbox${disallowed_plans[i]}`)

            if (elem != null) {
              if (!elem.disabled) {

                elem.disabled = false
              }
              else {
                elem.disabled = false
              }
            }
          }, 100);

        }
      }
      this.allplansArray[productName][planName].planCheckbox = false;
      this.changePlanCheckedValues(productName, planKey, parentId)
    }
    this.checkForAllPlansChecked(productName, planKey, parentId)
    this.checkForClassic()
  }

  planKeyCheckbox(productName: any, planKey: any, parentId: any, event: any) {
    if (event.target.checked) {
      this.plansError = false

      this.allplansArray[productName][planKey].checked = true
      Object.keys(this.allplansArray[productName]).forEach((p, id) => {
        if (typeof this.allplansArray[productName][p] === 'object' && typeof this.allplansArray[productName][p].hasOwnProperty('parentId')) {
          if (this.allplansArray[productName][p]['parentId'] == parentId) {
            this.allplansArray[productName][p]['planCheckbox'] = true
            this.logger.log(this.allplansArray[productName][p]['parentId'] == parentId, this.allplansArray[productName][p]['planCheckbox'],)

          }
        }
      })
    }
    else {
      this.allplansArray[productName][planKey].checked = false
      Object.keys(this.allplansArray[productName]).forEach((p, id) => {
        if (typeof this.allplansArray[productName][p] === 'object' && typeof this.allplansArray[productName][p].hasOwnProperty('parentId')) {
          if (this.allplansArray[productName][p]['parentId'] == parentId) {
            this.allplansArray[productName][p]['planCheckbox'] = false
          }
        }
      })
    }
    this.logger.log({ "plansArray": this.allplansArray })
    this.checkForAllPlansChecked(productName, planKey, parentId)
    this.checkForClassic()
  }


  initializeCustomizePlansArray(formLevels: any) {
    Object.keys(this.allplansArray).forEach((product) => {
      // this.logger.log({ product })
      Object.keys(this.allplansArray[product]).forEach((plan) => {
        // this.logger.log(this.allplansArray[product][plan])

        if (typeof this.allplansArray[product][plan] == "object" && this.allplansArray[product][plan]['planId'] != null) {
          this.logger.log(product, plan, this.allplansArray[product], this.allplansArray[product][plan])

          this.allplansArray[product][plan]['planCheckbox'] = formLevels.includes(this.allplansArray[product][plan]['planId'])

        }

      })

    })

    Object.keys(this.allplansArray).forEach((product) => {
      Object.keys(this.allplansArray[product]).forEach((plan) => {

        if (typeof this.allplansArray[product][plan] == "object" && this.allplansArray[product][plan]['isParent'] == true) {
          this.changePlanCheckedValues(product, plan, this.allplansArray[product][plan].id)
        }
      })

    })
    this.checkForClassic()
    this.logger.log({ plansArrayCustomise: this.allplansArray })
  }


  editadvisorformDetails(e, i, form) {
    this.showaddform = false;
    // this.isEditableForm =false;
    // this.enableEditIndexForm = i;
    // this.logger.log(i, e);
    // this.addformDetails = JSON.parse(sessionStorage.getItem('addformDetails'))


    this.editFormDetails = form

    this.logger.log(form, form.filterProductType)
    this.editindex = i;
    this.editFormType = form.formType;
    this.editFormName = form.name;
    this.editFormDescription = form.description;
    this.editFormlink = "";
    this.editFormlogo = form.logo || "/assets/img/logo.png";
    this.editFormDisclousreAggrement = "";
    this.planLevels = form.planLevels
    this.editFormPricingOptions = form.filterProductType;
    sessionStorage.setItem('editFormType',this.editFormType)





    if (this.editFormType === 'REGULAR') {
      this.initializePlansArray(this.productsArray, true, false, 'REGULAR')
    }
    if (this.editFormType === 'EXECUTIVE') {
      this.initializePlansArray(this.productsArray, false, false, 'EXECUTIVE')
    }
    if (this.editFormType === 'CUSTOM') {
      this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')

    }


    if (form.signupFormPlanLevels) {

      if (form.formType == 'CUSTOM') {

        this.customForm = true

        const plansSelected = form.signupFormPlanLevels.map((plan) => (
          plan.planLevelId
        ))
        this.selectedPlanLevels = plansSelected;
        this.logger.log({ plansSelected })

        this.selectedItems = form.planLevels
        this.initializeCustomizePlansArray(plansSelected)

        // this.form['formplanLevels'].setValidators([Validators.required]);;

        // this.form['formplanLevels'].updateValueAndValidity();
      }
      else {
        this.customForm = false
        // this.form['formplanLevels'].clearValidators();

        // this.form['formplanLevels'].updateValueAndValidity();
      }


    }
    else {

      this.customForm = false
      // this.form['formplanLevels'].clearValidators();

      // this.form['formplanLevels'].updateValueAndValidity();
    }
    this.showPlans = true
    this.showaddplans = false;
    this.showeditplans = true;
    $('#signupformedit').modal('show');
  }

  deletelicense(license: any, i: number) {

    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this_License + "?",
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: this.lang.Cancel,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        var accessToken = sessionStorage.getItem('accessToken');
        var deleteBrokerlicens = '/api/ap/broker/' + license.brokerId + '/license/' + license.id + '';

        this.http
          .delete(environment.apiUrl + deleteBrokerlicens, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {

                this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                    "message": "Advisors information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                })

                this.getBrokerDetails()
                Swal.fire({ title: this.lang.Info, text: response.message })

                //this.getServiceWorkerDetails()
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );

      }
    })


  }

  deleteEO(license: any, index: number) {

    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this_E_O,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: this.lang.Cancel,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {


        var accessToken = sessionStorage.getItem('accessToken');
        var deleteBrokerlicenseEO = '/api/ap/broker/' + license.brokerId + '/EOI';

        this.http
          .delete(environment.apiUrl + deleteBrokerlicenseEO, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {

                this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                    "message": "Advisors information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                })

                this.getBrokerDetails()
                //  this.getServiceWorkerDetails()
                this.eoform.reset()
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  cancelButtonText: this.lang.Cancel,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );

      }
    })


  }

  deleteResource(license: any, event: any) {
    console.log(event)

    Swal.fire({
      title: this.lang.Alert,
      text: "Are you sure you want to delete this " + event + "?",
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: this.lang.Cancel,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        // /broker/unlinkResources
        var accessToken = sessionStorage.getItem('accessToken');
        var deleteBroker = '/api/ap/broker/unlinkResources';


        let objDetails = {}
        if (event == 'Disclosure Agreement') {
          objDetails = {
            "id": this.brokerid,
            "disclosureAgreement": true,
            "termsAndConditions": false,
            "logo": false
          }

        }
        if (event == 'Terms and Conditions') {
          objDetails = {
            "id": this.brokerid,
            "disclosureAgreement": false,
            "termsAndConditions": true,
            "logo": false
          }
        }
        if (event == 'Logo') {
          objDetails = {
            "id": this.brokerid,
            "disclosureAgreement": false,
            "termsAndConditions": false,
            "logo": true
          }
        }


        this.http
          .post(environment.apiUrl + deleteBroker, objDetails, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // this.getBrokerDetails()
                this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                    "message": "Advisors information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                  window.location.reload()
                })

                //  this.getServiceWorkerDetails()
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  cancelButtonText: this.lang.Cancel,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );

      }
    })


  }
  addeditResources(event: any) {
    this.getResourcesFile = event
  }
  getResourceEvent(event: any) {
    console.log(event.target.value)

    this.showresourcefile = true

    if (event.target.value == 'disclosureAgreement') {
      this.getResourcesFile = "Disclosure Agreement"
    }
    if (event.target.value == 'TermsandConditions') {
      this.getResourcesFile = "Terms And Conditions"
    }
    if (event.target.value == 'logo') {
      this.getResourcesFile = "Logo"
    }

  }
  deleteForm(from: any, i: number) {


    // this.logger.log(from)
    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this_form + "",
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: this.lang.Cancel,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        // this.brokerFormData.splice(i, 1);
        var accessToken = sessionStorage.getItem('accessToken');
        var deleteBrokerForm = '/api/ap/broker/form/' + from.id + '';

        this.http
          .delete(environment.apiUrl + deleteBrokerForm, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {

                this.getBrokerDetails()
                //this.getServiceWorkerDetails()
                this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                    "message": "Advisors information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                })

              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  cancelButtonText: this.lang.Cancel,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
        if (this.brokerFormData.length == 0) {
          this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
          this.showaddform = true;
          this.showFormsDetails = false;
          this.showPlans = true;
        }
        else {
          this.showaddform = false;
          this.showFormsDetails = true;
          this.showPlans = false;
        }
      }
    })
  }
  saveForm(form: any, index: number) {

    this.logger.log(form)
    this.logger.log(index)


    let obj = {
      formType: form.formType,
      name: form.name,
      description: form.description,
      link: "",
      planLevels: form.planLevels || [],
      logo: form.logo || "",
      // formDisclosureAgreement: this.licenseform.value.formdisclosureAgreement || "",
    };


    this.addformDetails[index] = obj;
    // this.addlicenseformData.push(obj);
    this.isEditableForm = true;
    this.enableEditIndexForm = null

    this.logger.log(this.addformDetails)
    sessionStorage.setItem(
      'addformDetails',
      JSON.stringify(this.addformDetails)
    );
  }

  cancellicneseEdit(e, i) {
    this.isEditable = true;
    this.enableEditIndex = null;
    this.getBrokerDetails()
    //this.getServiceWorkerDetails()

  }
  cancelEOEdit(e, i) {
    this.isEditableEO = true;
    this.enableEditIndexEO = null;
    this.getBrokerDetails()
    //this.getServiceWorkerDetails()

  }
  cancelFormEdit(e, i) {
    this.isEditableForm = true;
    this.enableEditIndexForm = null;

    this.logger.log(this.globalbrokerFormData)
    this.brokerFormData = this.globalbrokerFormData
    this.logger.log(this.brokerFormData)
  }

  // brokertype(brokerType){

  //   if(brokerType=="Brokerage"){
  //       this.showBusinessnumber =true
  //   }
  //   else{
  //     this.showBusinessnumber =false
  //   }

  // }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
  copy(text: string) {


    this._clipboardService.copy(text)
  }
  copylink() {
    this.toastrService.success("link copied to Clipboard");
  }
  brokertype(brokerType) {
    // alert(brokerType)

    if (brokerType == "BROKERAGE") {
      this.showBusinessnumber = true

      this.broker['businessnumber'].setValidators([Validators.required]);

      this.broker['businessnumber'].updateValueAndValidity();

      // this.stc_generation = "false"
    }
    else {
      this.showBusinessnumber = false

      // this.stc_generation = "true"

      this.broker['businessnumber'].clearValidators();

      this.broker['businessnumber'].updateValueAndValidity();
    }

  }
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  addnewlicense() {
    this.licenseform.reset();
    this.licenseform.get('licenseCoverage').setValue('');
    this.licenseform.get('licenseCoverage').updateValueAndValidity();
    this.licenseform.get('state').setValue('');
    this.licenseform.get('state').updateValueAndValidity();
  }
  addlicense() {
    if (this.licenseform.invalid) {
      this.logger.log(this.licenseform.value);
      return;
    }
    this.logger.log(JSON.stringify(this.licenseform.value, null, 2));

    let obj = {
      provinces_id: this.insurancestate_id,
      provinces_name: this.insurancestatename,
      expiry_date: moment(this.licenseform.value.expiryDate, "MMM-DD-YYYY").format("MMM-DD-YYYY"),
      reminder_email: parseInt(this.licenseform.value.remainder_days),
      license_num: this.licenseform.value.licenseNumber,
      license_coverage: this.licenseform.value.licenseCoverage,
    };

    var accessToken = sessionStorage.getItem('accessToken');
    var addlcienseinfo = '/api/ap/broker/' + this.brokerid + '/brokerStateLicense';

    this.http
      .post(environment.apiUrl + addlcienseinfo, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {

            this.getBrokerDetails()

            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })

            Swal.fire({ title: this.lang.Info, text: response.message })
            // this.getServiceWorkerDetails()
            this.addlicenseformData.push(obj);
            this.licenseform.reset();
            $('#addLicenseModal').modal('hide');
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );



  }

  addeo() {
    if (this.eoform.invalid) {
      this.logger.log(this.eoform);
      return;
    }
    this.logger.log(this.eoform)


    var accessToken = sessionStorage.getItem('accessToken');
    var updateLicenseEO = '/api/ap/broker/' + this.brokerid + '/updateLicenceEO';



    let data = {
      "certificateNumber": this.eoform.value.certificateNumber,
      "expiryDate": moment(this.eoform.value.expiryDate, "MMM-DD-YYYY").format("MMM-DD-YYYY"),
      "insurerName": this.capitalize(this.eoform.value.insurerName),
      "policyNumber": this.eoform.value.policyNumber
    }


    this.http
      .put(environment.apiUrl + updateLicenseEO, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            Swal.fire({ title: this.lang.Info, text: response.message })
            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
            this.eoform.reset()

            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            $('#addEoInfo').modal('hide');

          } else {
            $('#addEoInfo').modal('hide');
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }
  addform() {

    // this.getPlansId()
    this.plansIds =  JSON.parse(sessionStorage.getItem('plansIds') ?? '[]')
    console.log('this.plansIds',this.plansIds);
    this.closePlans()
    
    this.plansIds.length <= 0 ? this.plansError = true : this.plansError = false
    if (this.formCreation.invalid || this.plansIds.length <= 0) {
      this.logger.log(this.formCreation.value, this.plansIds);
      return;
    }
    this.logger.log(JSON.stringify(this.formCreation.value, null, 2));

    let formDetails = []

    // if (this.formCreation.value.formplanLevels && this.formCreation.value.formplanLevels.length > 0) {
    //   let formplansData = this.formCreation.value.formplanLevels

    //   for (let i = 0; i < formplansData.length; i++) {
    //     this.fromplansarry.push(formplansData[i].id)
    //   }
    // }
    let logoDetails = '';
    if (this.uploadFormlogo) {

      (logoDetails = this.uploadFormlogo),
        'form_logo' +
        Date.now() +
        '.' +
        this.uploadFormlogo.name.split('.').pop().toLowerCase();

    } else {

      logoDetails = '';
    }

    let image;

    if (this.uploadFormlogo) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadFormlogo);

      reader.onload = (_event) => {

        image = reader.result
        this.editFormlogo = image
      };
    }

    var form = new FormData();
    var form1 = new FormData();
    let obj = {
      formType: 'CUSTOM',
      name: this.capitalize(this.formCreation.value.formName),
      description: this.capitalize(this.formCreation.value.formDescription),
      link: "",
      planLevelsisName: false,
      planLevels: this.plansIds || [],
      productType: this.formCreation.value.pricingOptions || "GIG",
      logo: logoDetails || "",
    };

    form1.append("formType", 'CUSTOM'),
      form1.append("name", this.capitalize(this.formCreation.value.formName)),
      form1.append("description", this.capitalize(this.formCreation.value.formDescription)),
      form1.append("link", ''),
      form1.append('formDetails', JSON.stringify(this.fromplansarry) || "");

    formDetails.push(obj)
    // let finalobj={
    //   broker_name: this.brokerinfoName,
    //   sales_tracking_code: "",
    //   formDetails:formDetails
    // }


    this.logger.log(formDetails)
    form.append("formDetails", JSON.stringify(formDetails));
    form.append("broker_name", this.brokerinfoName);
    form.append("sales_tracking_code", '');
    form.append("logo", logoDetails || "");


    var accessToken = sessionStorage.getItem('accessToken');
    var addlcienseinfo = '/api/ap/v2/broker/' + this.brokerid + '/createFormWithLogo';

    var requestOptions: any = {
      method: 'POST',

      body: form,

      redirect: 'follow',
      headers: { Authorization: 'Bearer ' + accessToken },
    };

    // this.logger.log(requestOptions)

    fetch(environment.apiUrl + addlcienseinfo, requestOptions)
      .then((response) => response.text())

      .then((response: any) => {
        response = JSON.parse(response);
        if (response['status'] == 200 || response['statusCode'] == 200) {

          this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
            this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
              "message": "Advisors information has been updated. Please refresh screen."
            }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((res) => {
              console.log({ res })
            })
          })

          this.getBrokerDetails()
          // this.getServiceWorkerDetails()
          this.addformDetails.push(obj);
          // // this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');

          this.formCreation.reset();
          this.showFormsDetails = true;
          this.showaddform = false;
          this.showPlans = false;
          this.showPricing = false



          this.fromplansarry = []
          this.customForm = false
          $('#addFormDetails').modal('hide');
          sessionStorage.setItem(
            'addformDetails',
            JSON.stringify(this.addformDetails)
          );


          this.uploadFormlogo = ""
          $('#basicModal1').modal('hide');
        } else {
          Swal.fire({ title: this.lang.Error??'Error', text: response.message })
        }
      },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              cancelButtonText: this.lang.Cancel,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );


    this.plansIds = []
    this.saveError = false


  }

  deletebrokerlicense(index: any) {
    const Data = this.addlicenseformData;
    const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

    sessionStorage.setItem(
      'addlicenseformData',
      JSON.stringify(this.addlicenseformData)
    );
    this.addlicenseformData = JSON.parse(
      sessionStorage.getItem('addlicenseformData') || '[]'
    );

    if (this.addlicenseformData.length == 0) {
      this.addlicenseform = true;
      this.addlicenseformtable = false;
    }
  }
  deleteform(form: any, index: any) {



    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_Form + form.name + '' + "?",
      showDenyButton: false,
      showCancelButton: true,

      cancelButtonText: this.lang.Cancel,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const Data = this.addformDetails;
        const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

        sessionStorage.setItem(
          'addformDetails',
          JSON.stringify(this.addformDetails)
        );
        this.addformDetails = JSON.parse(
          sessionStorage.getItem('addformDetails') || '[]'
        );

        if (this.addformDetails.length == 0) {
          this.showaddform = true;
          this.showPlans = true;
          this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
          this.showFormsDetails = false;
        }

      }
    })

  }

  editbrokerlicense(broker: any, index: any) {
    this.logger.log(broker);
    this.editindex = index;
    this.editbrokerlicensenumber = broker.license_num;
    this.editbrokerlicensecoverage = broker.license_coverage;
    this.editbrokerlicensestate = broker.provinces_name;
    this.editbrokerlicenseexpirydate = broker.expiry_date;
    this.editbrokerlicenseexpiryremainder = broker.reminder_email;
  }

  editform(form: any, index: any) {

    this.editindex = index;
    this.editFormType = 'CUSTOM'
    this.editFormName = form.name;
    this.editFormDescription = form.description;
    this.editFormlink = "";
    this.editFormlogo = "";
    this.editFormDisclousreAggrement = "";
  }





  editbrokerlicenseSubmit() {
    if (this.licenseform.invalid) {
      this.logger.log(this.licenseform);
      return;
    }
    this.logger.log(JSON.stringify(this.licenseform.value, null, 2));

    let obj = {
      provinces_id: this.insurancestate_id,
      provinces_name: this.insurancestatename,
      expiry_date:
        this.datePipe.transform(
          this.licenseform.value.expiryDate,
          'MMM-dd-yyyy'
        ) || '',
      reminder_email: parseInt(this.licenseform.value.remainder_days),
      license_num: this.licenseform.value.licenseNumber,
      license_coverage: this.licenseform.value.licenseCoverage,
    };
    this.addlicenseformData[this.editindex] = obj;

    sessionStorage.setItem(
      'addlicenseformData',
      JSON.stringify(this.addlicenseformData)
    );
    this.addlicenseformData = JSON.parse(
      sessionStorage.getItem('addlicenseformData') || '[]'
    );

    this.licenseform.reset();
    this.addlicenseform = false;
    this.addlicenseformtable = true;
    $('#basicModaledit').modal('hide');
    // $('#basicModal1').modal('hide');
  }

  uploadadminFormlogo(event1: any) {
    this.logger.log('test');

    this.logger.log(event1)
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.uploadFormlogo = event1.target.files[0];

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      'application/pdf',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploadFormlogo.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadFormlogo.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          // this.showimagelogo = false;
          this.editFormlogo = reader.result;
          // this.imagedisplay = reader.result;
        };
      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang.File_size_is_too_large_maximum_file_size_is_1_MB;
        alert(message);
      }
    } else {
      error = true;

      message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
      alert(message);
    }
  }



  getPlansId() {
    this.plansIds = []
    Object.keys(this.allplansArray).forEach((product: any) => {
      return Object.keys(this.allplansArray[product]).forEach((plan: any) => {
        // if (typeof this.allplansArray[product][plan] === 'object' && this.allplansArray[product][plan].planCheckbox === true && this.allplansArray[product][plan].planId) {
        if (typeof this.allplansArray[product][plan] === 'object' && this.allplansArray[product][plan].plancheckkbox === true && this.allplansArray[product][plan].planId) {
          this.logger.log(this.allplansArray[product][plan].planId, plan)
          this.plansIds.push(this.allplansArray[product][plan].planId)
        }
      })
    })
    this.plansIds = this.plansIds.filter(item => item !== null);
    this.logger.log("planIds", this.plansIds)
  }


  resetFormCreation() {
    this.plansError = false;
    this.formCreation.reset()
    this.allplansArray = []

    this.closePlans();
  }
  editFormSubmit() {
    // this.getPlansId()
    this.plansIds =  JSON.parse(sessionStorage.getItem('plansIds') ?? '[]')
    console.log('this.plansIds',this.plansIds);

    this.logger.log(this.formCreation.controls);
    this.plansIds.length <= 0 ? this.plansError = true : this.plansError = false

    if (this.formCreation.invalid || this.plansIds.length <= 0) {
      this.logger.log(this.formCreation.value, this.plansIds.length);
      return;
    }
    // this.logger.log(JSON.stringify(this.formCreation.value, null, 2));

    var accessToken = sessionStorage.getItem('accessToken');


    var saveAdvisorForm = '/api/ap/broker/' + this.editFormDetails.brokerId + '/form/' + this.editFormDetails.id + '/modify';


    let logoDetails = '';
    if (this.uploadFormlogo) {
      (logoDetails = this.uploadFormlogo),
        'form_logo' +
        Date.now() +
        '.' +
        this.uploadFormlogo.name.split('.').pop().toLowerCase();
    } else {
      logoDetails = '';
    }


    let image;

    if (this.uploadFormlogo) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadFormlogo);

      reader.onload = (_event) => {

        image = reader.result
        this.editFormlogo = image
      };
      this.showPlans = false
    }
    // if (this.formCreation.value.formplanLevels && this.formCreation.value.formplanLevels.length > 0) {
    //   let formplansData = this.formCreation.value.formplanLevels

    //   for (let i = 0; i < formplansData.length; i++) {
    //     this.fromplansarry.push(formplansData[i].id)
    //   }
    // }

    let obj = {
      formType: 'CUSTOM',
      name: this.capitalize(this.formCreation.value.formName),
      description: this.capitalize(this.formCreation.value.formDescription),
      link: "",
      planLevels: this.plansIds || [],
      logo: logoDetails || "",
      formDisclosureAgreement: "",
      productType: this.formCreation.value.pricingOptions || "GIG",

    };


    this.logger.log(obj)

    var form = new FormData();
    form.append("newType", 'CUSTOM');
    form.append("name", this.capitalize(this.formCreation.value.formName));
    form.append("description", this.capitalize(this.formCreation.value.formDescription));
    form.append("nameOrId", "false");
    form.append("planlevel", JSON.stringify(obj.planLevels) || "[]");
    form.append("logo", logoDetails || "");
    form.append("productType", this.formCreation.value.pricingOptions || "GIG");



    var requestOptions: any = {
      method: 'POST',

      body: form,

      redirect: 'follow',
      headers: { Authorization: 'Bearer ' + accessToken },
    };

    this.logger.log(requestOptions)

    fetch(environment.apiUrl + saveAdvisorForm, requestOptions)
      .then((response) => response.text())

      .then((response: any) => {
        this.uploadFormlogo = ''
        response = JSON.parse(response);
        Swal.fire({ title: this.lang.Info, text: response.message })

        this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
          this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
            "message": "Advisors information has been updated. Please refresh screen."
          }, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe((res) => {
            console.log({ res })
          })
        })

        this.closePlans()

        this.getBrokerDetails()
        // this.getServiceWorkerDetails()
        this.addformDetails[this.editindex] = obj;

        this.formCreation.reset();
        this.showFormsDetails = true;
        this.showaddform = false;
        sessionStorage.setItem(
          'addformDetails',
          JSON.stringify(this.addformDetails)
        );
        $('#signupformedit').modal('hide');


      })

    this.plansIds = []
  }



  hideaddlicenseform() {
    this.licenseform.reset();
  }
  addextraform() {
    // sessionStorage.setItem('editFormType','')
    this.customForm = false
    // this.form['formplanLevels'].clearValidators();

    // this.form['formplanLevels'].updateValueAndValidity();
    this.allplansArray = []
    this.initializePlansArray(this.productsArray, false, false, 'CUSTOM');
    this.showPlans = true;
    this.formCreation.reset();
    // $('#addFormDetails').modal('show');
    // this.formCreation.reset();
    // this.showaddform = true;
    
    this.showaddplans = true;
    this.showeditplans = false;
    $('#addFormDetails').modal('show');
  }
  public disclosureAgg = '';
  public imageDisclosure = '';
  uploadadmindisclosure(event1: any) {
    this.uploaddisclousreAggrement = ''
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    console.log(event1.target.files[0].name);
    this.uploaddisclousreAggrement = event1.target.files[0];
    this.disclosureAgg = event1.target.files[0].name;
    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      'application/pdf',
    ];

    const extensionImageMap = {
      '.pdf': '../../../assets/img/pdf.png',
      '.png': '../../../assets/img/png.png',
      '.jpg': '../../../assets/img/jpg.png',
    };

    this.imageDisclosure = extensionImageMap[fileExtension.toLowerCase()] || '';
    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploaddisclousreAggrement.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploaddisclousreAggrement.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showdisclosureaggrement = false;

          this.imagedisplaypdf = reader.result;
          console.log(this.imagedisplaypdf)
        };

        let aggrement = ''
        if (this.uploaddisclousreAggrement) {
          (aggrement = this.uploaddisclousreAggrement),
            'Admin_logo' +
            Date.now() +
            '.' +
            this.uploaddisclousreAggrement.name.split('.').pop().toLowerCase();
        } else {
          aggrement = '';
        }

        var formdata = new FormData();

        console.log(this.getResourcesFile)

        if (this.getResourcesFile == "Disclosure Agreement") {

          formdata.append('id', this.showsoleAdvisorDataResult.id);
          formdata.append('name', this.showsoleAdvisorDataResult.name);
          formdata.append('logo', '');
          formdata.append('useParentsLogo', 'false');
          formdata.append('uploadLogo', 'false');
          formdata.append('parentId', this.showsoleAdvisorDataResult.parentId);
          formdata.append('disclosureAgreement', aggrement);
          formdata.append('uploadDisclosureAgreement', 'true');
          formdata.append('useParentsDisclosure', 'false');
          formdata.append('uploadTermsAndConditions', 'false');
          formdata.append('useParentsTerms', 'false');
          formdata.append('termsAndConditions', 'false');
        }
        if (this.getResourcesFile == "Terms And Conditions") {

          formdata.append('id', this.showsoleAdvisorDataResult.id);
          formdata.append('name', this.showsoleAdvisorDataResult.name);
          formdata.append('logo', '');
          formdata.append('useParentsLogo', 'false');
          formdata.append('uploadLogo', 'false');
          formdata.append('parentId', this.showsoleAdvisorDataResult.parentId);
          formdata.append('disclosureAgreement', '');
          formdata.append('useParentsDisclosure', 'false');
          formdata.append('uploadTermsAndConditions', 'true');
          formdata.append('useParentsTerms', 'false');
          formdata.append('termsAndConditions', aggrement);
        }

        if (this.getResourcesFile == "Logo") {

          formdata.append('id', this.showsoleAdvisorDataResult.id);
          formdata.append('name', this.showsoleAdvisorDataResult.name);
          formdata.append('logo', aggrement);
          formdata.append('useParentsLogo', 'false');
          formdata.append('uploadLogo', 'true');
          formdata.append('parentId', this.showsoleAdvisorDataResult.parentId);
          formdata.append('disclosureAgreement', '');
          formdata.append('uploadDisclosureAgreement', 'false');
          formdata.append('useParentsDisclosure', 'false');
          formdata.append('uploadTermsAndConditions', 'false');
          formdata.append('useParentsTerms', 'false');
          formdata.append('termsAndConditions', 'false');
        }


        var endPoint = '/api/ap/broker/uploadResources';
        var accessToken = sessionStorage.getItem('accessToken');

        var requestOptions: any = {
          method: 'POST',

          body: formdata,

          redirect: 'follow',
          headers: { Authorization: 'Bearer ' + accessToken },
        };
        fetch(environment.apiUrl + endPoint, requestOptions)
          .then((response) => response.text())

          .then((response: any) => {


            response = JSON.parse(response);

            if (response['status'] == 200) {
              this.toastrService.success(this.getResourcesFile + " Uploaded successfully", 'success');

              $(`#addResources`).hide();
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                  "message": "Advisors information has been updated. Please refresh screen."
                }, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  }
                }).subscribe((res) => {
                  console.log({ res })
                })
                window.location.reload();
              })
            }

            if (response['status'] == 202) {
              Swal.fire({ title: 'Info', text: "No parent logo exists, please upload logo" });
            }
          })
      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`;
        alert(message);
      }
    } else {
      error = true;

      message = 'Invalid file type. Only jpg, png image,pdf files are allowed.';
      alert(message);
    }
  }

  checkfile(event: any) {
    this.getResourcesFile = event
  }

  uploadadminlogo(event1: any) {
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();
    console.log({ fileExtension });
    this.uploadlogo = event1.target.files[0];


    var allowedMimes = ['image/jpeg', 'image/pjpeg', 'image/png'];

    let error = false;
    let message = '';

    if (allowedMimes.includes(this.uploadlogo.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadlogo.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showimagelogo = false;

          this.imagedisplay = reader.result;
          // this.displaylogo = reader.result;
        };

        let logo = ''
        if (this.uploadlogo) {
          (logo = this.uploadlogo),
            'Admin_logo' +
            Date.now() +
            '.' +
            this.uploadlogo.name.split('.').pop().toLowerCase();
        } else {
          logo = '';
        }
        var formdata = new FormData();


        formdata.append('id', this.showsoleAdvisorDataResult.id);
        formdata.append('name', this.showsoleAdvisorDataResult.name);
        formdata.append('logo', logo);
        formdata.append('useParentsLogo', 'false');
        formdata.append('uploadLogo', 'true');
        formdata.append('parentId', this.showsoleAdvisorDataResult.parentId);
        formdata.append('disclosureAgreement', '');
        formdata.append('uploadDisclosureAgreement', 'false');
        formdata.append('useParentsDisclosure', 'false');
        formdata.append('uploadTermsAndConditions', 'false');
        formdata.append('useParentsTerms', 'false');
        formdata.append('termsAndConditions', 'false');




        var endPoint = '/api/ap/broker/uploadResources';
        var accessToken = sessionStorage.getItem('accessToken');

        var requestOptions: any = {
          method: 'POST',

          body: formdata,

          redirect: 'follow',
          headers: { Authorization: 'Bearer ' + accessToken },
        };

        // console.log(requestOptions)

        fetch(environment.apiUrl + endPoint, requestOptions)
          .then((response) => response.text())

          .then((response: any) => {

            response = JSON.parse(response);

            if (response['status'] == 200) {
              this.toastrService.success("Logo Uploaded successfully", 'success');

              $(`#addResourceLogo`).hide();
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                  "message": "Advisors information has been updated. Please refresh screen."
                }, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  }
                }).subscribe((res) => {
                  console.log({ res })
                })
                window.location.reload();
              })
            }
            else {
              Swal.fire({ title: 'Info', text: "No parent logo exists, please upload logo" });

            }
          })


      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`;
        // alert(message);
      }
    } else {
      error = true;
      message = 'Invalid file type. Only jpg,jpeg,png image files are allowed.';
      // alert(message);
    }
    if (error) {
      Swal.fire({
        title: 'Error',
        text: message,
      }).then((res) => {
        if (res.isConfirmed) {
          this.broker['logo'].setValue(null);
        }
      });
    }
  }
  // viewDisclosure(broker: any) {
  //   this.disclosuredisplaypdf1 = environment.apiUrl + "/api/ap/" + broker
  // }
  viewDisclosure(broker: any) {
    if(broker.includes('https')){
      this.disclosuredisplaypdf1 = broker
    } else{
      this.disclosuredisplaypdf1 = environment.apiUrl + "/api/ap/" + broker
    }
  }
  // uploadadminlogo(event1: any) {
  //   this.logger.log('test');
  //   var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

  //   // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
  //   this.uploadlogo = event1.target.files[0];

  //   var allowedMimes = [
  //     'image/jpeg',
  //     'image/pjpeg',
  //     'image/png',
  //     'application/pdf',
  //   ];

  //   let error = false;

  //   let message = '';

  //   if (allowedMimes.includes(this.uploadlogo.type)) {
  //     if (this.uploadlogo.size <= 1024 * 1024) {
  //       //300KB

  //       error = false;
  //       var reader = new FileReader();
  //       reader.readAsDataURL(event1.target.files[0]);

  //       reader.onload = (_event) => {
  //         this.showimagelogo = false;

  //         this.imagedisplay = reader.result;
  //       };
  //     } else {
  //       error = true;
  //       message = this.lang.File_size_is_too_large_maximum_file_size_is_1_MB;
  //       alert(message);
  //     }
  //   } else {
  //     error = true;

  //     message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
  //     alert(message);
  //   }
  // }
  // uploadadmindisclosure(event1: any) {
  //   this.logger.log('test');
  //   var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

  //   // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
  //   this.uploaddisclousreAggrement = event1.target.files[0];

  //   var allowedMimes = [
  //     'image/jpeg',
  //     'image/pjpeg',
  //     'image/png',
  //     'application/pdf',
  //   ];

  //   let error = false;

  //   let message = '';

  //   if (allowedMimes.includes(this.uploaddisclousreAggrement.type)) {
  //     if (this.uploaddisclousreAggrement.size <= 300 * 1024) {
  //       //300KB

  //       error = false;
  //       var reader = new FileReader();
  //       reader.readAsDataURL(event1.target.files[0]);

  //       reader.onload = (_event) => {
  //         this.showdisclosureaggrement = false;

  //         this.imagedisplaypdf = reader.result;
  //       };
  //     } else {
  //       error = true;
  //       message = this.lang.File_size_is_too_large_maximum_file_size_is_1_MB;
  //       alert(message);
  //     }
  //   } else {
  //     error = true;

  //     message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
  //     alert(message);
  //   }
  // }
  public openPdf() {
    $('#disclosure').modal('show');
  }
  closePopup(id: any) {
    $(`#${id}`).hide();
    this.showresourcefile = false
    this.showdisclosureaggrement = true
    this.resourceFileuplaod = ''
  }
  formConfig() {

    // var endPoint = `/api/ap/broker/formConfig?currentBrokerId=${this.route.snapshot.params['id']}`;
    // var accessToken = sessionStorage.getItem('accessToken');

    // this.http
    //   .get(environment.apiUrl + endPoint, {
    //     headers: {
    //       Authorization: 'Bearer ' + accessToken,
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       if (response['status'] == 200) {
    //         this.getBrokerDetails()
    //         // this.getServiceWorkerDetails()
    //         this.allBrokers = response.data.allBrokers;
    //         this.configprovinceres = response.data.states.sort(
    //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //         );
    //         this.productsArray = response.data.packages

    //         console.log(this.productsArray)
    //         this.prevSTC = response.data.prevSTC;
    //         this.licenseCoverage = response.data.licenseCoverage;
    //         this.brokerType = response.data.brokerType;
    //         this.formType = response.data.formType;
    //         this.pricingOptions = response.data.forms

    //         this.advisorGroupContact = response.data.advisorGroupContact
    //       } else {
    //         Swal.fire({ title: this.lang.Error??'Error', text: response.message });
    //       }
    //     },
    //     (error) => {
    //       if (
    //         error.status == 400 ||
    //         error.status == 401 ||
    //         error.status == 402 ||
    //         error.status == 403
    //       ) {
    //         Swal.fire({
    //           title: this.lang.Error??'Error',
    //           text: error.error.error.message,
    //           showDenyButton: false,
    //           showCancelButton: false,
    //           cancelButtonText: this.lang.Cancel,
    //           confirmButtonText: 'Ok',
    //         }).then((result) => {
    //           if (result.isConfirmed) {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //         });
    //       } else {
    //         Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
    //       }
    //     }
    //   );

    this.store.dispatch(loadBrokerFormConfigData());
    this.brokerFormConfigData$ = this.store.select(state => state.brokerFormConfigData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );
    this.brokerFormConfigData$.subscribe(data => {

      if(data){
        console.log(data)
        // if (data?.brokerConfigData == undefined || Object.keys(data.brokerConfigData).length <= 0) {
        if (data?.brokerFormConfigData == undefined || Object.keys(data.brokerFormConfigData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if(Object.keys(this.brokerConfigData).length>0){
          return;
        }
        this.getBrokerDetails()
        this.brokerConfigData = {};
        this.brokerConfigData = {...data.brokerFormConfigData};
        console.log('this.brokerConfigData',this.brokerConfigData.states)

        setTimeout(() => {
          this.allBrokers = this.brokerConfigData.allBrokers;
          this.configprovinceres = [...this.brokerConfigData.states].sort(
            (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
          );

          // this.productsArray = this.brokerConfigData.packages

          this.prevSTC = this.brokerConfigData.prevSTC;
          this.licenseCoverage = this.brokerConfigData.licenseCoverage;
          this.brokerType = this.brokerConfigData.brokerType;
          this.formType = this.brokerConfigData.formType;
          this.pricingOptions = this.brokerConfigData.forms

          this.advisorGroupContact = this.brokerConfigData.advisorGroupContact
          const accessToken = sessionStorage.getItem('accessToken')
          this.http.get(environment.apiUrl+`/api/ap/v2/rest/broker/formConfig?currentBrokerId=${this.route.snapshot.params['id']}`,{
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          }).subscribe((res:any)=>{
            console.log(res)
            this.productsArray = res?.data?.packages
          })
        },0);
      }
    })
  }

  changeCountry(){
    console.log(this.country)
    const country = [...this.brokerConfigData?.allCountrys].find(c => c.name?.toLowerCase() == this.country?.toLowerCase());

    this.configprovinceres = [...this.brokerConfigData?.states.filter((state:any)=>state?.countryId == country?.id)].sort(
      (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    );
    console.log(this.configprovinceres)
  }

  public provincelist(event: any) {
    // alert(event.target.value)

    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provineList=element
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.id);
        this.statename = element.name;
      }
    });



    if (this.brokerregform.controls['postalCode'].value) {
      if (
        this.provineList.zipcodes
          .split(',')
          .indexOf(this.brokerregform.controls['postalCode'].value[0]) == -1
      ) {
        this.invalidpostalcodeprivince = true;
        this.brokerregform.controls['postalCode'].markAsTouched();
      } else {
        this.invalidpostalcodeprivince = false;
      }

      if (this.brokerregform.controls['postalCode'].value.length == 0) {
        this.invalidpostalcodeprivince = false;
      }
    }
  }
  public insuranceprovincelist(event: any) {
    // alert(event.target.value)

    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.insurancestate_id = parseInt(element.id);
        this.insurancestatename = element.name;
      }
    });
  }
  changeTextToUppercase(field: any, event: any) {
    // this.logger.log(field);
    // const obj = {};

    // this.postalvalue = event.target.value;

    // if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
    //   // this.logger.log("r")
    //   this.invalidpostalcodeprivince = true;
    //   this.broker['postalCode'].markAsTouched();
    // } else {
    //   this.invalidpostalcodeprivince = false;
    // }

    // if (this.postalvalue.length == 0) {
    //   this.invalidpostalcodeprivince = false;
    // }

    // this.logger.log(this.invalidpostalcodeprivince);

    const obj: any = {};
    obj['postalCode'] =
      this.brokerregform.controls['postalCode'].value?.toUpperCase();

    this.brokerregform.patchValue(obj);
    if (
      this.provineList.zipcodes.split(',').indexOf(event.target.value[0]) == -1
    ) {
      this.invalidpostalcodeprivince = true;
    } else {
      this.invalidpostalcodeprivince = false;
      var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
      if (event.target.value && !postalRegexp.test(event.target.value)) {
        this.invalidpostalcodeprivince = true;
      } else {
        this.invalidpostalcodeprivince = false;
      }
    }

    if (event.target.value.length == 0) {
      this.invalidpostalcodeprivince = false;
    }
  }

  public signupFormCheck(event) {
    this.logger.log(event);

    if (event.target.value == 'true') {
      this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
      this.showaddform = true;
      this.showPlans = true;
      this.allplansArray = []
      this.formCreation.reset()
    } else {
      // this.showformtype = false;
      this.showaddform = false;
      this.allplansArray = []
      this.showPlans = false;
      this.saveError = false;

      this.formCreation.reset()

    }
  }
  public checkParentlogo(event) {
    if (event.target.value == 'true') {
      this.showparentlogocondition = false;
    } else {
      this.showparentlogocondition = true;
    }
  }
  public checkParentdisclosure(event) {
    if (event.target.value == 'true') {
      this.showparentdisclosurecondition = false;
      this.broker['disclosureAgreement'].clearValidators();

      this.broker['disclosureAgreement'].updateValueAndValidity();
      this.uploaddisclousreAggrement = ""
    } else {
      this.showparentdisclosurecondition = true;
      this.broker['disclosureAgreement'].setValidators([Validators.required]);

      this.broker['disclosureAgreement'].updateValueAndValidity();
    }
  }


  showPlansForSelection(type: string) {
    if (type === 'REGULAR') {
      this.initializePlansArray(this.productsArray, true, true, 'REGULAR')
    }
    if (type === 'EXECUTIVE') {
      this.initializePlansArray(this.productsArray, false, true, 'EXECUTIVE')
    }
    if (type === 'CUSTOM') {
      this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
    }
  }

  public selectFormname(event: any) {
    this.logger.log(event.target.value);
    this.showPlans = true;
    this.showPlansForSelection(event.target.value)

    if (event.target.value == 'REGULAR' || event.target.value == 'EXECUTIVE') {
      // this.showaddform = true;
      this.customForm = false
      // this.form['formplanLevels'].clearValidators();

      // this.form['formplanLevels'].updateValueAndValidity();
    } else {
      this.customForm = true
      // this.form['formplanLevels'].setValidators([Validators.required]);;

      // this.form['formplanLevels'].updateValueAndValidity();
    }
    for (let i = 0; i < this.formType.length; i++) {

      if (this.formType[i].label == event.target.value) {

        // this.formTitle = this.formType[i].title
        // this.formDescription = this.formType[i].description
        this.formCreation.get('formName').setValue(this.formType[i].title);
        this.formCreation.get('formDescription').setValue(this.formType[i].description);
        this.cdr.detectChanges();
        setTimeout(() => {
          this.cdr.detectChanges(); // Ensure change detection runs after the current cycle
        });
      }

    }
  }

  onFormTitleChange(value: string) {
    this.formTitle = value;
    // this.formCreation.get('formName').setValue(value);
    // Detect changes here if needed
    this.cdr.detectChanges();
  }
  
  onFormDescriptionChange(value: string) {
    this.formDescription = value;
    // this.formCreation.get('formDescription').setValue(value);
    // Detect changes here if needed
    this.cdr.detectChanges();
  }

  public getBrokerlistData(event: any) {
    this.logger.log(event.target.value);

    // alert(this.brokerregform.value.ParentbrokerName);
  }




  gotoadvsiorpage() {
    this.router.navigate(['/manageAdvisors']);
  }
  public submitbasicInfo() {
  // alert(this.invalidpostalcodeprivince)

    this.plansIds.length <= 0 && this.showaddform ? this.saveError = true : this.saveError = false
    this.logger.log(this.plansIds.length <= 0, this.formCreation.invalid)

    if (this.brokerregform.invalid) {
      console.log(this.brokerregform.value);

      const invalid = [];
      const controls = this.brokerregform.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      console.log(invalid)

      this.brokerregform.markAllAsTouched();
      this.licenseform.markAllAsTouched();
      this.formCreation.markAllAsTouched();
      if (this.saveError) {
        const buttonToScrollTo = this.elementRef.nativeElement.querySelector('#scrollTarget');
        this.logger.log({ buttonToScrollTo })

        // buttonToScrollTo.scrollIntoView({ behavior: 'smooth' });
      }
    }

    else {
      if (this.invalidpostalcodeprivince == false) {
        this._LoaderService.ShowLoader()
        let secondaryEmail = this.brokerregform.value.secondaryEmail || "";
        let thirdEmail = this.brokerregform.value.thirdEmail;

        if (thirdEmail) {
          secondaryEmail = `${secondaryEmail ? `${secondaryEmail},` : ''}${thirdEmail}`;
        }



        let obj = {
          apt: "",
          city: this.capitalize(this.brokerregform.value.city),
          country: this.capitalize(this.brokerregform.value.country),
          line1: this.capitalize(this.brokerregform.value.streetAddress),
          line2: this.capitalize(this.brokerregform.value.streetAddress2),
          postalCode: this.brokerregform.value.postalCode,
          primaryEmail: this.brokerregform.value.primaryEmail,
          primaryPhone: this.brokerregform.value.primaryPhone,
          secondaryEmail: secondaryEmail || "",
          secondaryPhone: this.brokerregform.value.secondaryPhone || "",
          state: this.brokerregform.value.Province
        }

        const secAndThirdMails = secondaryEmail.split(',')
        if (secAndThirdMails.length > 1) {
          if (secAndThirdMails.includes(this.primaryEmail)) {
            const index = secAndThirdMails.indexOf(this.primaryEmail)
            this._LoaderService.HideLoader()
            if (index == 0) {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: this.lang.Primary_and_secondary_email_must_be_different })
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: this.lang.Primary_and_third_email_must_be_different })
            }
            return;

          } else if (secAndThirdMails[0] == secAndThirdMails[1]) {
            this._LoaderService.HideLoader()
            Swal.fire({ title: this.lang.Error ?? 'Error', text: this.lang.Secondary_and_third_email_must_be_different })
            return;

          }

        } else {
          if (secAndThirdMails[0] == this.primaryEmail) {
            this._LoaderService.HideLoader()
            Swal.fire({ title: this.lang.Error ?? 'Error', text: this.lang.Primary_and_secondary_email_must_be_different })
            return;
          }
        }
        var updatebasicConatctInfo = '/api/ap/broker/' + this.brokerid + '/updateContactInfo';
        var accessToken = sessionStorage.getItem('accessToken');
        this.http
          .put(environment.apiUrl + updatebasicConatctInfo, obj, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            async (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {



                this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                    "message": "Advisors information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    this.brokerList = this.brokerList.map(broker =>
                      broker.id == this.brokerid ? { ...broker, email: obj.primaryEmail } : broker
                    );
                    this.brokerDetails.primaryEmail = obj.primaryEmail
                    this.store.dispatch(loadAdvisorDataSuccess({ advisorData: this.brokerList }))
                    console.log({ res })
                  })
                })

                this._LoaderService.HideLoader();
                Swal.fire({ title: this.lang.Info, text: response.message }).then(response => {
                  if (response.isConfirmed) {
                    // $("#advisorModal").hide();
                    // window.location.reload();
                    $("#closeModalDetails").click();
                    this.getBrokerDetails();
                  }
                })

              } else {
                this._LoaderService.HideLoader()

                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
              }
            },
            (error) => {
              this._LoaderService.HideLoader()

              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  cancelButtonText: this.lang.Cancel,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );

      }
    }

  }
  alphabatesOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length == 0) {
      if ((charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) || ((charCode >= 192 && charCode <= 255)) || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95)
        return true;
      else return false;
    }
    else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) || ((charCode >= 192 && charCode <= 255)) ||
        charCode === 32 || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95)
        return true;
      else return false;
    }
  }
  public capitalize(str: any) {
    // if (str) {
    //   return str.charAt(0).toUpperCase() + str.slice(1);
    // }
    const arr = str.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);

    }
    const str2 = arr.join(" ");
    return str2
  }

  closePlans(){
    this.showaddplans = false;
    this.showeditplans = false;
  }
}
export function postalcodeValidator(control: AbstractControl) {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null;
}